module.exports = __webpack_public_path__ + "static/media/slick.d41f55a7.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slick-carousel/slick/fonts/slick.ttf
// module id = 381
// module chunks = 0